import { memo } from 'react';
import { CardGlass, CardContent } from '@/components/ui/card';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Star } from 'lucide-react';

const testimonials = [{
  name: 'Aminata Diallo',
  role: 'Pour l\'anniversaire de sa mère',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Aminata',
  quote: 'J\'ai offert un QR Portrait à ma mère pour ses 60 ans. Quand elle a scanné le code et vu toutes nos photos de famille avec ma voix, elle a pleuré de joie. Un moment magique !',
  rating: 5
}, {
  name: 'Mamadou Kane',
  role: 'Cadeau pour sa fiancée',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mamadou',
  quote: 'Original et touchant. Ma fiancée a adoré ! Le cadre est de très belle qualité et le QR Code fonctionne parfaitement. C\'est devenu notre cadeau signature pour la famille.',
  rating: 5
}, {
  name: 'Fatou Sarr',
  role: 'Pour son meilleur ami',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Fatou',
  quote: 'Super simple à créer, résultat incroyable ! Mon meilleur ami était vraiment ému. L\'idée du message audio rend le tout encore plus personnel. Je recommande à 100% !',
  rating: 5
}, {
  name: 'Ousmane Ndiaye',
  role: 'Cadeau de départ collègue',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ousmane',
  quote: 'Nous avons créé un QR Portrait collectif pour le départ d\'un collègue. Chacun a ajouté un mot, des photos d\'équipe... Il était très touché. Parfait pour les cadeaux de groupe !',
  rating: 5
}];

export const TestimonialsSection = memo(() => {
  return (
    <section className="py-20 px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
            Ils ont déjà offert l'émotion
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto">
            Rejoignez des centaines de personnes qui ont créé des souvenirs inoubliables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <CardGlass 
              key={testimonial.name} 
              className="hover-lift animate-scale-in" 
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6 space-y-4">
                {/* Header with avatar and info */}
                <div className="flex items-center gap-3">
                  <Avatar className="h-12 w-12 ring-2 ring-primary/20 soft-shadow">
                    <AvatarImage src={testimonial.avatar} alt={testimonial.name} />
                    <AvatarFallback className="bg-primary/10 text-primary font-bold text-sm">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex-1">
                    <p className="text-sm font-bold text-foreground">{testimonial.name}</p>
                    <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                  </div>
                </div>

                {/* Rating stars */}
                <div className="flex gap-1">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star 
                      key={i} 
                      className="w-4 h-4 fill-primary text-primary animate-scale-in" 
                      style={{ animationDelay: `${index * 0.1 + i * 0.05}s` }} 
                    />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-sm text-foreground/90 leading-relaxed italic border-l-4 border-primary/30 pl-3">
                  "{testimonial.quote}"
                </blockquote>
              </CardContent>
            </CardGlass>
          ))}
        </div>
      </div>
    </section>
  );
});

TestimonialsSection.displayName = 'TestimonialsSection';
